import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SelectField } from "../ui/Field";

const PAGE_SIZES = [10, 25, 50, 100].map((n) => ({ value: String(n), label: `${n} per page` }));

export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-ink-200 bg-paper px-4 py-2.5">
      <p className="text-xs text-ink-600">
        Showing <span className="font-semibold text-ink-900">{from}</span>–
        <span className="font-semibold text-ink-900">{to}</span> of {total}
      </p>

      <div className="flex items-center gap-3">
        <SelectField
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          options={PAGE_SIZES}
          className="w-32"
          aria-label="Rows per page"
        />

        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page <= 1}
            aria-label="Previous page"
            className="flex h-8 w-8 items-center justify-center rounded border border-ink-200 bg-white text-ink-600 transition-colors hover:bg-ink-100 disabled:opacity-40"
          >
            <ChevronLeft className="h-4 w-4" aria-hidden="true" />
          </button>
          <span className="px-2 text-xs font-semibold text-ink-700">
            {page} / {totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page >= totalPages}
            aria-label="Next page"
            className="flex h-8 w-8 items-center justify-center rounded border border-ink-200 bg-white text-ink-600 transition-colors hover:bg-ink-100 disabled:opacity-40"
          >
            <ChevronRight className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
